import { BasicTrackingEvent } from "./BasicTrackingEvent";

export class OpenAfterPushNotificationTrackingEvent extends BasicTrackingEvent {
    public playerId: number = -1;
    public pushNotificationId: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = {};
        vars.playerId = this.playerId;
        vars.var_1 = this.pushNotificationId;
        return vars;
    }
}
